/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D", "\u661F\u671F\u65E5"], e = ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u65E5"], t = ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"], s = "\u5E74", d = "\u672C\u5E74", o = "\u6708", y = "\u5468", n = "\u65E5", r = "\u4ECA\u65E5", D = "\u6682\u65E0\u6D3B\u52A8", M = "\u6574\u5929", Y = "\u5220\u9664", l = "\u65B0\u5EFA\u6D3B\u52A8", h = "YYYY MMMM D dddd", k = { weekDays: a, weekDaysShort: e, months: t, years: "\u5E74", year: "\u672C\u5E74", month: "\u6708", week: "\u5468", day: "\u65E5", today: "\u4ECA\u65E5", noEvent: "\u6682\u65E0\u6D3B\u52A8", allDay: "\u6574\u5929", deleteEvent: "\u5220\u9664", createEvent: "\u65B0\u5EFA\u6D3B\u52A8", dateFormat: "YYYY MMMM D dddd" };
export {
  M as allDay,
  l as createEvent,
  h as dateFormat,
  n as day,
  k as default,
  Y as deleteEvent,
  o as month,
  t as months,
  D as noEvent,
  r as today,
  y as week,
  a as weekDays,
  e as weekDaysShort,
  d as year,
  s as years
};
